/* eslint-disable no-var, prefer-template, no-new-func */
export function transformError(payload, item) {
  var error = item.err || {};

  if (error.isDalError) {
    payload.fingerprint = error.name + ' ' + error.code + ': ' + error.message + ' (' + error.details + ')';
    payload.dalError = {
      code: error.code,
      details: error.details,
      httpStatus: error.httpStatus,
      method: error.method,
      path: error.path,
      endpoint: error.endpoint,
      requestId: error.requestId,
    };
  }

  if (error.sagaStack) {
    payload.sagaStack = error.sagaStack;
  }
}

export const transformErrorFlattened = new Function(
  `return ${transformError
    .toString()
    .replace(/\n/g, '')
    .replace(/ {2,}/g, ' ')}`
)();
/* eslint-enable */
